import { useEffect, useState } from "react";
import { TextField, Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setDialog,
  resetForm,
  Supplier,
} from "../../../../app/slices/supplierSlice";
import { SelectProvince } from "../../../../components/Selectors/SelectProvince";
import { Controller, useForm } from "react-hook-form";
import { HiOutlineTruck, HiOutlineMapPin } from "react-icons/hi2";
import FormDialog, { SectionCard } from "../../../../components/FormDialog";

const SupplierForm = () => {
  const _Supplier = useSelector((state) => state.supplier.supplier);
  const _SearchBody = useSelector((state) => state.supplier.searchBody);

  const isAdd = _Supplier.form.id ? false : true;
  const { control, reset, handleSubmit, setValue } = useForm({
    defaultValues: {
      province: {
        id: _Supplier.form.province_id,
        name: _Supplier.form.province_name,
      },
      ..._Supplier.form,
    },
  });

  const [saving, setSaving] = useState(false);

  const onSubmit = async (data) => {
    setSaving(true);
    try {
      if (isAdd) {
        await dispatch(
          Supplier.create({
            name: data.name,
            province_id: data.province?.id,
          })
        );
      } else {
        await dispatch(
          Supplier.update(
            data.id,
            {
              name: data.name,
              province_id: data.province?.id,
            },
            _SearchBody
          )
        );
      }
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    reset({
      ..._Supplier.form,
      province: {
        id: _Supplier.form.province_id,
        name: _Supplier.form.province_name,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_Supplier.form]);

  useEffect(() => {
    return () => {
      dispatch(resetForm());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setDialog());
  };

  return (
    <FormDialog
      open={_Supplier.dialog}
      onClose={handleClose}
      icon={<HiOutlineTruck />}
      title={isAdd ? "إضافة مورد جديد" : "تعديل بيانات المورد"}
      subtitle={
        isAdd
          ? "أدخل معلومات المورد لإضافته الى القائمة"
          : "قم بتحديث معلومات المورد ثم احفظ التغييرات"
      }
      onSubmit={handleSubmit(onSubmit)}
      saving={saving}
    >
      <SectionCard icon={<HiOutlineMapPin />} title="معلومات المورد">
        <Grid item xs={12}>
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <TextField
                required
                size="small"
                label="الاسم"
                fullWidth
                {...field}
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name="province"
            control={control}
            render={({ field }) => (
              <SelectProvince
                required
                value={field.value}
                onChange={(e, newValue) =>
                  setValue(
                    "province",
                    newValue ? { id: newValue.id, name: newValue.name } : null
                  )
                }
              />
            )}
          />
        </Grid>
      </SectionCard>
    </FormDialog>
  );
};

export default SupplierForm;
